// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"263":"479bdc9e","594":"8fc1ae98"}[chunkId] + ".js";
};